/* eslint-disable @typescript-eslint/no-explicit-any */
import { Row, Skeleton } from 'antd';
import React, { useContext, useEffect, useState } from 'react';
import { DragDropContext, Draggable, Droppable } from 'react-beautiful-dnd';
import { useParams } from 'react-router-dom';
import swal from 'sweetalert';
import axiosInstance from '../../../../../../axios_instance';
import {
  IsAdminContext,
  NumberOfSoftSkillontext,
  SkillListContext,
  UserSkillDataContext,
} from '../../../../../../context';
import { reorder } from '../../../../../../utils/helper';
import styles from '../styles.module.scss';
import AddSkill from './add-skill';
import SkillDetail from './skill-detail-view';

//The parent component of soft skill's card
const SoftSkillCard: React.FC<any> = (): JSX.Element => {
  const [userSkillData, setUserSkillData] = useState<any>([]);
  //state to store all skills from database
  const [skillList, setSkillList] = useState<any>();
  const [addNew, setAddNew] = useState<boolean>(false);
  const isAdmin = useContext(IsAdminContext);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  //This url query parameter will be available for admin user
  const { employeeId } = useParams();
  const [message, setMessage] = useState<string>();
  const { numberOfSoftSkills, setNumberOfSoftSkills } = useContext(
    NumberOfSoftSkillontext
  );

  //retrieve all skills from database.User can select skill from available skills in this list.
  useEffect(() => {
    axiosInstance.get('/api/v1/skills').then((response) => {
      const allSkills = response.data.skills.filter(
        (skill: any) => skill['skill_type']['id'] === 2
      );
      const skills = allSkills.reduce(
        // eslint-disable-next-line @typescript-eslint/ban-types
        (initialList: Object, CurrentList: { [key: string]: any }) => ({
          ...initialList,
          [CurrentList.skill_name]: CurrentList.skill_id,
        }),
        {}
      );
      console.log(skills);
      setSkillList(skills);
    });
  }, []);

  //retrieve user's all skills information.
  useEffect(() => {
    let url = '';
    if (isAdmin === '1') {
      url = '/api/v1/profile/admin/user-profiles/' + employeeId + '/skills';
    } else {
      url = '/api/v1/profile/user-profiles/skills';
    }
    axiosInstance
      .get(url)
      .then((response) => {
        let userSkills: Array<any> = [];
        if (response.data.skills.length !== 0) {
          userSkills = response.data.skills.filter(
            (skill: any) =>
              skill['status']['id'] === 1 && skill['skill_type']['id'] === 2
          );
          const orderedSkills = response.data.order_soft_skills
            .map((skillId: number) =>
              userSkills.find(
                (userSkill: any) => userSkill.skill_id === skillId
              )
            )
            .filter((item: any) => item !== undefined);
          setUserSkillData(orderedSkills);
          console.log(orderedSkills);
        } else {
          setUserSkillData(response.data.skills);
        }
        setNumberOfSoftSkills(userSkills.length);
      })
      .catch((error) => {
        setMessage("Something went wrong!Items couldn't be loaded!");
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, []);

  const onDragEnd = (result: any) => {
    // dropped outside the list
    if (!result.destination) {
      return;
    }
    if (userSkillData.length < 2) {
      return;
    }
    if (result.source.index === result.destination.index) {
      return;
    }

    const items = reorder(
      userSkillData,
      result.source.index,
      result.destination.index
    );
    const order_list = items.map((item: any) => item.skill_id);
    setUserSkillData(items);

    const payload: any = {
      type: 'soft_skills',
      updated_reorder_list: order_list,
    };
    if (isAdmin === '1') {
      payload.profile_id = employeeId;
    }

    axiosInstance
      .post('/api/v1/reorder', payload)
      .then((response) => {
        swal({
          title: 'Updated',
          text: 'Order of soft skill has been updated',
          icon: 'success',
        }).then((willRefresh) => {
          console.log();
        });
      })
      .catch((error) => {
        swal({
          title: 'Failed',
          text: 'Order of soft skill could not be updated',
          icon: 'error',
        }).then((willRefresh) => {
          console.log();
        });
      });
  };

  return (
    <div style={{ position: 'relative' }}>
      <UserSkillDataContext.Provider
        value={{ userSkillData, setUserSkillData }}
      >
        <SkillListContext.Provider value={{ ...skillList }}>
          {isLoading ? (
            <Skeleton active />
          ) : (
            <DragDropContext onDragEnd={onDragEnd}>
              <Droppable droppableId="droppable">
                {(provided: any, snapshot: any) => (
                  <div {...provided.droppableProps} ref={provided.innerRef}>
                    {userSkillData.map((item: any, index: any) => (
                      <Draggable
                        key={`row_${item.skill_id}`}
                        draggableId={`row_${item.skill_id}`}
                        index={index}
                      >
                        {(provided: any, snapshot: any) => (
                          <div
                            ref={provided.innerRef}
                            {...provided.draggableProps}
                            {...provided.dragHandleProps}
                          >
                            <SkillDetail key={index} {...item} />
                          </div>
                        )}
                      </Draggable>
                    ))}
                    {provided.placeholder}
                  </div>
                )}
              </Droppable>
            </DragDropContext>
          )}
          {message ? <p style={{ color: 'red' }}>{message}</p> : <></>}
          {addNew ? <AddSkill {...{ setAddNew: setAddNew }} /> : <></>}

          <Row style={{ position: 'relative' }}>
            <p
              className={styles['add-new']}
              // eslint-disable-next-line @typescript-eslint/no-unused-vars
              onClick={(e) => {
                setAddNew(true);
              }}
            >
              Add New (+)
            </p>
          </Row>
        </SkillListContext.Provider>
      </UserSkillDataContext.Provider>
    </div>
  );
};

export default SoftSkillCard;
